import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { MessageService } from 'primeng/api';

import { routes } from '@app/app.routes';
import { HttpConfigInterceptor } from '@shared/interceptor/http.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideAnimationsAsync(), // for browser animations
        provideHttpClient(withInterceptorsFromDi()), // for http client
        MessageService,
        {
            provide: HTTP_INTERCEPTORS, // for http client
            useClass: HttpConfigInterceptor,
            multi: true,
        },
    ],
};
